export default __webpack_public_path__ + "media/zurb/img/ecommerce/getup_pdp-04fe46da914871d55f92dc8bb38ad864.png";